module.exports = __webpack_public_path__ + "static/img/onlinea.276a375.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/we/onlinea.jpg
 ** module id = 595
 ** module chunks = 2
 **/